<div class="contenedor-filtros p-16">
    <h2 class="m-0">Filtros</h2>
    <mat-divider></mat-divider>
    <br />
    <div
        fxLayoutGap="30px"
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign="space-between center"
    >
        <!-- mat-form-field class="full-width">
            <mat-label>OOTT</mat-label>

            <mat-chip-list #nroOOTTList aria-label="OOTT" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let nroOOTSeleccionada of filtros.nroOOTT"
                    [removable]="true"
                    (removed)="quitarFiltro('nroOOTT')"
                >
                    <span>{{ nroOOTSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.nroOOTT[0].descripcion === '*'"
                    #oottInput
                    type="number"
                    [formControl]="nroOOTTCtrl"
                    [matChipInputFor]="nroOOTTList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro($event, nroOOTTCtrl, 'nroOOTT')
                    "
                />
            </mat-chip-list>
        </mat-form-field -->
        <mat-form-field class="full-width">
            <mat-label>Ticket</mat-label>

            <mat-chip-list
                #nroTicketList
                aria-label="Ticket"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let nroTicketSeleccionado of filtros.nroTicket"
                    [removable]="true"
                    (removed)="quitarFiltro('nroTicket')"
                >
                    <span>{{ nroTicketSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.nroTicket[0].descripcion === 'Todos'"
                    #ticketInput
                    [formControl]="nroTicketCtrl"
                    [matChipInputFor]="nroTicketList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro($event, nroTicketCtrl, 'nroTicket')
                    "
                />
            </mat-chip-list>
        </mat-form-field>
        <!-- mat-form-field class="full-width">
            <mat-label>Nombre contratista</mat-label>

            <mat-chip-list
                #nombreContratistaList
                aria-label="Nombre contratista"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="
                        let nombreContratistaSeleccionado of filtros.nombreContratista
                    "
                    [removable]="true"
                    (removed)="quitarFiltro('nombreContratista')"
                >
                    <span>{{ nombreContratistaSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.nombreContratista[0].descripcion === '*'"
                    #nombreInput
                    [formControl]="nombreContratistaCtrl"
                    [matChipInputFor]="nombreContratistaList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro(
                            $event,
                            nombreContratistaCtrl,
                            'nombreContratista'
                        )
                    "
                />
            </mat-chip-list>
        </mat-form-field -->
        <!-- mat-form-field class="full-width">
            <mat-label>Rut contratista</mat-label>

            <mat-chip-list
                #rutContratistaList
                aria-label="Rut contratista"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="
                        let rutContratistaSeleccionado of filtros.rutContratista
                    "
                    [removable]="true"
                    (removed)="quitarFiltro('rutContratista')"
                >
                    <span>{{ rutContratistaSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.rutContratista[0].descripcion === '*'"
                    #rutInput
                    type="number"
                    [formControl]="rutContratistaCtrl"
                    [matChipInputFor]="rutContratistaList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="
                        agregarFiltro(
                            $event,
                            rutContratistaCtrl,
                            'rutContratista'
                        )
                    "
                />
            </mat-chip-list>
        </mat-form-field -->

        <mat-form-field
            class="full-width"
            *ngIf="_menuUsuarioSrvc.esSupervisor()"
        >
            <mat-label>Clientes</mat-label>
            <mat-chip-list
                #clientesList
                aria-label="Clientes"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let clienteSeleccionado of filtros.idCliente"
                    [removable]="true"
                    (removed)="quitarFiltro('idCliente')"
                >
                    <span>{{ clienteSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.idCliente[0].descripcion === 'Todos'"
                    #clienteInput
                    [formControl]="clienteCtrl"
                    [matAutocomplete]="autCompleteCliente"
                    [matChipInputFor]="clientesList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autCompleteCliente="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'nombre',
                        clienteCtrl,
                        'clienteInput',
                        'idCliente'
                    )
                "
            >
                <mat-option
                    *ngFor="let clienteFiltrado of filteredClientes | async"
                    [value]="clienteFiltrado"
                >
                    {{ clienteFiltrado.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Estado</mat-label>
            <mat-chip-list #estadoList aria-label="Estado" [multiple]="false">
                <mat-chip
                    class="primary"
                    *ngFor="let estadoSeleccionado of filtros.estadoOOTT"
                    [removable]="true"
                    (removed)="quitarFiltro('estadoOOTT')"
                >
                    <span>{{ estadoSeleccionado.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.estadoOOTT[0].descripcion === 'Todos'"
                    #estadoInput
                    [formControl]="estadoCtrl"
                    [matAutocomplete]="autoCompleteEstado"
                    [matChipInputFor]="estadoList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteEstado="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'descripcion',
                        estadoCtrl,
                        'estadoInput',
                        'estadoOOTT'
                    )
                "
            >
                <mat-option
                    *ngFor="let estadoFiltrado of filteredEstados | async"
                    [value]="estadoFiltrado"
                >
                    {{ estadoFiltrado.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Situación</mat-label>
            <mat-chip-list
                #situacionList
                aria-label="Situacion"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let situacionSeleccionada of filtros.situacion"
                    [removable]="true"
                    (removed)="quitarFiltro('situacion')"
                >
                    <span>{{ situacionSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.situacion[0].descripcion === 'Todos'"
                    #situacionInput
                    [formControl]="situacionCtrl"
                    [matAutocomplete]="autoCompleteSituacion"
                    [matChipInputFor]="situacionList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteSituacion="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'nombre',
                        situacionCtrl,
                        'situacionInput',
                        'situacion'
                    )
                "
            >
                <mat-option
                    *ngFor="let situacionFiltrado of filteredSituacion | async"
                    [value]="situacionFiltrado"
                >
                    {{ situacionFiltrado.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>


        <mat-form-field class="full-width">
            <mat-label>Pago Contratista</mat-label>
            <mat-chip-list
                #pagoList
                aria-label="EstadoPago"
                [multiple]="false"
            >
                <mat-chip
                    class="primary"
                    *ngFor="let estadoPagoSeleccionada of filtros.estadoPago"
                    [removable]="true"
                    (removed)="quitarFiltro('estadoPago')"
                >
                    <span>{{ estadoPagoSeleccionada.descripcion }}</span>
                    <mat-icon matChipRemove class="grey-50-fg">cancel</mat-icon>
                </mat-chip>
                <input
                    *ngIf="filtros.estadoPago[0].descripcion === 'Todos'"
                    #estadoPagoInput
                    [formControl]="estadoPagoCtrl"
                    [matAutocomplete]="autoCompleteEstadoPago"
                    [matChipInputFor]="pagoList"
                />
            </mat-chip-list>
            <mat-autocomplete
                #autoCompleteEstadoPago="matAutocomplete"
                (optionSelected)="
                    seleccionarFiltro(
                        $event,
                        'id',
                        'nombre',
                        estadoPagoCtrl,
                        'estadoPagoInput',
                        'estadoPago'
                    )
                "
            >
                <mat-option
                    *ngFor="let estadoPagoFiltrado of filteredEstadoPago | async"
                    [value]="estadoPagoFiltrado"
                >
                    {{ estadoPagoFiltrado.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>


    </div>
    <div fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="start start">
        <button
            mat-raised-button
            color="primary"
            (click)="limpiarTodosFiltros()"
        >
            <mat-icon>clear</mat-icon>
            Limpiar filtros
        </button>
        <button mat-raised-button color="accent" (click)="filtrar()">
            <mat-icon>tune</mat-icon> Filtrar
        </button>
    </div>
</div>
